import React, {useEffect} from "react";
import {useSelector} from "react-redux";
import {css, Theme} from "@emotion/react";

import {m, mt, onDesktop} from "@pg-design/helpers-css";
import {FaqSection} from "@pg-mono/faq";

import {IRPStore} from "../../app/rp_reducer";
import {CreditCalculatorFirstOfSecton} from "../components/CreditCalculatorFirstOfSecton";
import {CreditCalculatorHeader} from "../components/CreditCalculatorHeader";
import {CreditCalculatorInfo} from "../components/CreditCalculatorInfo";
import {CreditCalculatorMoreInfo} from "../components/CreditCalculatorMoreInfo";
import {CreditKnowledgeBase} from "../components/CreditKnowledgeBase";
import {CreditBreadcrumbs} from "../components/CreditsBreadcrumbs";
import {CreditStepByStep} from "../components/raiting_calculator/CreditStepByStep";
import {CreditViewEvent} from "../tracking/analytics/credit_view_event";
import {CreditAlgolyticsViewType} from "../tracking/types/CreditAlgolyticsViewType";

const knowledgeCopy =
    "Kredyt hipoteczny wymaga od nas odpowiedniej wiedzy. Podejmij decyzję o finansowaniu świadomie! Dowiesz się m.in. czym jest hipoteka, jak zgromadzić i co może być wkładem własnym, a także - jak pracować z kredytem, nadpłacając zobowiązanie, lub refinansując kredyt hipoteczny. Już teraz sprawdź Strefę Wiedzy rynekpierwotny.pl!";

export const CreditCalculatorView = () => {
    useEffect(() => {
        CreditViewEvent({view_type: CreditAlgolyticsViewType.CREDIT});
    }, []);

    const faq = useSelector((state: IRPStore) => state.faq.data);
    return (
        <div css={mainWrapper}>
            <CreditBreadcrumbs />

            <CreditCalculatorHeader />

            <CreditCalculatorInfo />

            <CreditCalculatorMoreInfo />

            <CreditCalculatorFirstOfSecton />

            <CreditStepByStep />

            <div css={articlesWrapper}>
                <CreditKnowledgeBase hideChecklist copyVariant={knowledgeCopy} />
            </div>

            <FaqSection faqContent={faq} css={mt(6)} />
        </div>
    );
};

const mainWrapper = (theme: Theme) => css`
    ${m(0, "auto", 4, "auto")}
    background-color: ${theme.colors.background["100"]};
`;
const articlesWrapper = css`
    ${m("auto")}
    ${onDesktop(css`
        max-width: 112.8rem;
    `)};
`;
import React, {useEffect} from "react";
import {useSelector} from "react-redux";
import {css, Theme} from "@emotion/react";

import {m, mt, onDesktop} from "@pg-design/helpers-css";
import {FaqSection} from "@pg-mono/faq";

import {IRPStore} from "../../app/rp_reducer";
import {CreditCalculatorFirstOfSecton} from "../components/CreditCalculatorFirstOfSecton";
import {CreditCalculatorHeader} from "../components/CreditCalculatorHeader";
import {CreditCalculatorInfo} from "../components/CreditCalculatorInfo";
import {CreditCalculatorMoreInfo} from "../components/CreditCalculatorMoreInfo";
import {CreditKnowledgeBase} from "../components/CreditKnowledgeBase";
import {CreditBreadcrumbs} from "../components/CreditsBreadcrumbs";
import {CreditStepByStep} from "../components/raiting_calculator/CreditStepByStep";
import {CreditViewEvent} from "../tracking/analytics/credit_view_event";
import {CreditAlgolyticsViewType} from "../tracking/types/CreditAlgolyticsViewType";

const knowledgeCopy =
    "Kredyt hipoteczny wymaga od nas odpowiedniej wiedzy. Podejmij decyzję o finansowaniu świadomie! Dowiesz się m.in. czym jest hipoteka, jak zgromadzić i co może być wkładem własnym, a także - jak pracować z kredytem, nadpłacając zobowiązanie, lub refinansując kredyt hipoteczny. Już teraz sprawdź Strefę Wiedzy rynekpierwotny.pl!";

export const CreditCalculatorView = () => {
    useEffect(() => {
        CreditViewEvent({view_type: CreditAlgolyticsViewType.CREDIT});
    }, []);

    const faq = useSelector((state: IRPStore) => state.faq.data);
    return (
        <div css={mainWrapper}>
            <CreditBreadcrumbs />

            <CreditCalculatorHeader />

            <CreditCalculatorInfo />

            <CreditCalculatorMoreInfo />

            <CreditCalculatorFirstOfSecton />

            <CreditStepByStep />

            <div css={articlesWrapper}>
                <CreditKnowledgeBase hideChecklist copyVariant={knowledgeCopy} />
            </div>

            <FaqSection faqContent={faq} css={mt(6)} />
        </div>
    );
};

const mainWrapper = (theme: Theme) => css`
    ${m(0, "auto", 4, "auto")}
    background-color: ${theme.colors.background["100"]};
`;
const articlesWrapper = css`
    ${m("auto")}
    ${onDesktop(css`
        max-width: 112.8rem;
    `)};
`;
